// extracted by mini-css-extract-plugin
export default {"mainContent":"Review_mainContent__UxyXQ","textContent":"Review_textContent__iVp+h","rating":"Review_rating__AsW3R"};